import { render, staticRenderFns } from "./RoomAndAdult.vue?vue&type=template&id=4a073bb6&scoped=true&"
import script from "./RoomAndAdult.vue?vue&type=script&lang=js&"
export * from "./RoomAndAdult.vue?vue&type=script&lang=js&"
import style0 from "./RoomAndAdult.vue?vue&type=style&index=0&id=4a073bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a073bb6",
  null
  
)

export default component.exports